import { initI18n, Messages } from '@wix/wix-i18n-config';

export interface InitialI18n {
  locale: string;
  resources: Messages;
}

export function clientI18n({ locale, resources }: InitialI18n) {
  return initI18n({
    locale,
    messages: resources,
  });
}
